/**
 * Asynchronously loads the component
 */
import React, { Component } from 'react';
import Loadable from 'react-loadable';
import { Redirect } from 'react-router-dom';
import { getUserData } from 'utils/graphQLFunctions';
import { isAuthenticated } from 'utils/auth';
import LoadingIndicator from 'components/LoadingIndicator';

const Loader = Loadable({
  loader: () => import('./index'),
  loading: LoadingComponent
});

class AdminLoadable extends Component {
  constructor(props) {
    super(props);
    this.isAuth = false;
  }

  componentWillMount() {
    this.isAuth = isAuthenticated();
  }

  render() {
    const { user, loading } = this.props.data;
    if (!this.isAuth) {
      return <Redirect to="/" />;
    } else if (loading) {
      return null;
    } else if (!user || !user.isAdmin) {
      return <Redirect to="/" />;
    } else {
      return <Loader />;
    }
  }
}

function LoadingComponent({ error, pastDelay }) {
  if (error) {
    return (
      <div>
        Failed to load component due to Error:
        {error.message || JSON.stringify(error)}
      </div>
    );
  } else if (pastDelay) {
    return <LoadingIndicator expand />;
  } else {
    return null;
  }
}

export default getUserData()(AdminLoadable);



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminLoadable.js